import type {
  BookingDetailsState,
  BookingDetailsStore,
} from '../domain/types'
import { createStore } from 'zustand'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { DEFAULT_FULL_CANCELLATION_COSTS_STATE } from '../domain/fullCancellationCostsRules'
import { DEFAULT_PARTIAL_CANCELLATION_FEE_STATE } from '../domain/partialCancellationFeeRules'

const defaultInitialState: BookingDetailsState = {
  bookingNumber: '',
  customerId: null,
  accommodations: [],
  groupName: '',
  groupSize: null,
  destination: '',
  rawDepartureDate: '',
  rawReturnDate: '',
  participants: {},
  bookingParticipantIds: [],
  payment: null,
  activeParticipantId: '',
  isGroupParticipant: false,
  isGroupResponsible: false,
  isGroupBooking: false,
  isSelfServiceEnabled: false,
  areServicesEditable: false,
  isCancelled: false,
  isAddedByYou: false,
  isTotallySnow: false,
  isPrimavera: false,
  groupSubscriptionModel: null,
  isMasterBooking: false,
  extras: [],
  specialLuggageExtras: [],
  preferences: [],
  customerSupportOpeningHours: '',
  travelGuideContactInfo: null,
  latitude: '',
  longitude: '',
  rebookedBookingNumber: '',
  bookingDetailsPageLoadStatus: 'idle',
  documents: { items: [], loadStatus: 'idle' },
  excursions: { items: [], loadStatus: 'idle', allExcursionsLink: '' },
  transfers: {
    type: null,
    outbound: null,
    inbound: null,
    loadStatus: 'idle',
  },
  deleteBookingRequestStatus: 'idle',
  isDeleteDialogOpen: false,
  isCancelBookingDialogOpen: false,
  canAccountBeDeleted: false,
  transportType: 'own-transport',
  hasCarRental: false,
  specialLuggage: { submitStatus: 'idle', isOpen: false },
  participantEdit: {
    isOpen: false,
    loadStatus: 'idle',
    submitStatus: 'idle',
    participantId: '',
    rules: [],
    wasSubmittedUnchanged: false,
    externalRequest: { isOpen: false, submitStatus: 'idle', isSent: false, wasSubmittedUnchanged: false },
  },
  editPreferences: {
    isOpen: false,
    loadStatus: 'idle',
    submitStatus: 'idle',
    wasSubmittedUnchanged: false,
    isStale: false,
    items: [],
  },
  busInformation: null,
  flightInformation: null,
  rebooking: null,
  rebookingSearchUrl: '',
  partialCancellationFee: DEFAULT_PARTIAL_CANCELLATION_FEE_STATE,
  fullCancellationCosts: DEFAULT_FULL_CANCELLATION_COSTS_STATE,
  cancelBookingSubmitStatus: 'idle',
  cancellationOptions: {
    isFullCancellable: false,
    isPartialCancellable: false,
    isRebookable: false,
    voucherCancellationUrl: null,
  },
}

export const bookingDetailsStore = createBookingDetailsStore()

export function createBookingDetailsStore(initialState: BookingDetailsState = defaultInitialState) {
  return createStore<BookingDetailsStore>(set => ({
    ...initialState,
    initialize: (state) => {
      set(() => state)
    },

    setIn: (path, value) => {
      set(state => setIn(state, path, value) as BookingDetailsState)
    },

    changeActiveParticipantId: (participantId) => {
      set(state => ({ ...state, activeParticipantId: participantId }))
    },
  }))
}
